import { render, staticRenderFns } from "./msgTplForm.vue?vue&type=template&id=3e9f1dae&scoped=true"
import script from "./msgTplForm.vue?vue&type=script&lang=js"
export * from "./msgTplForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f1dae",
  null
  
)

export default component.exports